// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    isQty?: boolean;
    qty?: number;
    uom?: string;
    productErp: string;
}

type HandlerType = Handler<Parameter>;

export const UpodateQty: HandlerType = props => {
    if (!props.parameter.isQty) {
        return;
    }
    props.dispatch({
        type: "ShopByLook/UpdateQty",
        qty: props.parameter.qty,
        productErp: props.parameter.productErp,
    } as any);
};

export const UpodateUom: HandlerType = props => {
    if (props.parameter.isQty) {
        return;
    }
    props.dispatch({
        type: "ShopByLook/UpdateUom",
        uom: props.parameter.uom,
        productErp: props.parameter.productErp,
    } as any);
};

export const chain = [UpodateQty, UpodateUom];

const updateShopByLookProduct = createHandlerChainRunner(chain, "UpdateShopByLookProduct");
export default updateShopByLookProduct;
